import React from 'react';

/** *************** ICONS WHICH ARE USED IN THE PAGES  *********** */
import { Icon } from '@chakra-ui/react';
import {
    MdOutlineDashboard,
    MdAdminPanelSettings,
    MdSupervisedUserCircle,
    MdOutlineDocumentScanner,
    MdOutlineHomeWork
} from 'react-icons/md';
import { ImUserTie } from 'react-icons/im';
import { AiOutlineUserAdd , AiFillCreditCard, AiOutlineDollarCircle } from 'react-icons/ai';
import { FaBuildingUser } from 'react-icons/fa6';
import { BiSolidMessageSquareDetail, BiSupport } from 'react-icons/bi';
import { FaAngellist } from 'react-icons/fa';
/** ********************** MAIN DASHBOARD  ***************** */
import MainDashboard from 'views/admin/default';
import OrgUserTables from 'views/admin/User';
import OrgCompany from 'views/admin/orgCompany/Allcompany';
import ViewRequests from 'views/admin/orgCompany/index';
import CompanyDashboard from 'views/admin/orgCompany/CompanyDashboard';
/** ************************** auth pages ***************** */
import SignInCentered from 'views/auth/signIn';
import ForgotPassword from 'views/auth/forgotPassword';
import ValidationUser from 'views/auth/validationUser';
import ResetPassword from 'views/auth/resetPassword';

import ApplicationDashboard from 'views/admin/Applications/Dashboard';
import ViewCompany from 'views/admin/orgCompany/viewCompany';
import Viewrequest from 'views/admin/orgCompany/Viewrequest';
import ViewUser from 'views/admin/User/ViewConsumer';

/** ***************** REALTOR PAGE *************** */
import RealtorHome from 'views/admin/Realtor/RealtorHome';
import RealtorDetails from 'views/admin/Realtor/RealtorDetails';

/** ***************** Comming Soon PAGE *************** */
import ComingSoon from 'views/admin/comingSoon';
import TransactionHome from 'views/admin/Transaction/TransactionHome';
import TransactionDetailsHeaders from 'views/admin/Transaction/TransactionDetailsHeaders';
import ViewCompanyUser from 'views/admin/orgCompany/ViewCompanyUser';

/** ************** Lender Invitations  ************ */
import RealtorInvitationDetails from 'views/admin/invitations/RealtorInvitationDetails';
import LenderInvitationDetails from 'views/admin/invitations/LenderInvitationDetails';
import Lenderinvitations from 'views/admin/invitations/Lenders';
import RealtorInvitations from 'views/admin/invitations/Realtors';

const routes = [
    {
        name: 'Dashboard',
        layout: '/organization',
        path: '/dashboard',
        icon: <Icon as={MdOutlineDashboard} width="20px" height="20px" color="inherit" />,
        component: MainDashboard,
        hideLink: false
    },

    {
        name: 'Application',
        layout: '/organization',
        path: '/application',
        icon: (
            <Icon
                as={MdOutlineDocumentScanner}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: ApplicationDashboard,
        hideLink: false
    },
    {
        name: 'Consumers',
        layout: '/organization',
        path: '/user/consumer/:id',
        icon: (
            <Icon
                as={MdSupervisedUserCircle}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: ViewUser,
        hideLink: true
    },
    {
        name: 'View Request',
        layout: '/organization',
        path: '/approvals/view-request/:id',
        icon: (
            <Icon
                as={MdOutlineHomeWork}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: Viewrequest,
        hideLink: true
    },
    {
        name: 'Approvals',
        layout: '/organization',
        path: '/approvals',
        icon: (
            <Icon
                as={FaAngellist}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: ViewRequests,
        hideLink: false

    },
    {
        name: 'View Realtor',
        layout: '/organization',
        path: '/user/realtor/:id',
        icon: (
            <Icon
                as={ImUserTie}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: RealtorDetails,
        hideLink: true
    },
    {
        name: 'View Lender',
        layout: '/organization',
        path: '/user/lender/details/:id',
        icon: (
            <Icon
                as={MdOutlineHomeWork}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: ViewCompany,
        hideLink: true
    },
    {
        name: 'Dashboard',
        layout: '/organization',
        path: '/invitations/realtors/:id',
        icon: (
            <Icon
                as={MdOutlineHomeWork}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: RealtorInvitationDetails,
        hideLink: true
    },
    {
        name: 'Dashboard',
        layout: '/organization',
        path: '/invitations/lenders/:id',
        icon: (
            <Icon
                as={MdOutlineHomeWork}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: LenderInvitationDetails,
        hideLink: true
    },

    {
        name: 'View Lender',
        layout: '/organization',
        path: '/user/lender/stats/:id',
        icon: (
            <Icon
                as={MdOutlineHomeWork}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: CompanyDashboard,
        hideLink: true
    },

    {
        name: 'View Lender',
        layout: '/organization',
        path: '/user/lender/user/:id',
        icon: (
            <Icon
                as={MdOutlineHomeWork}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: ViewCompanyUser,
        hideLink: true
    },
    {
        name: 'User',
        layout: '/organization',
        path: '/user',
        icon: (
            <Icon
                as={FaBuildingUser}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        hideLink: false,
        items: [
            {
                name: 'Consumers',
                layout: '/organization',
                path: '/user/consumer',
                icon: (
                    <Icon
                        as={MdSupervisedUserCircle}
                        width="20px"
                        height="20px"
                        color="inherit"
                    />
                ),
                component: OrgUserTables
            },
            {
                name: 'Lender',
                layout: '/organization',
                path: '/user/lender',
                icon: (
                    <Icon
                        as={MdOutlineHomeWork}
                        width="20px"
                        height="20px"
                        color="inherit"
                    />
                ),
                component: OrgCompany
            },
            {
                name: 'Realtor',
                layout: '/organization',
                path: '/user/realtor',
                icon: (
                    <Icon
                        as={ImUserTie}
                        width="20px"
                        height="20px"
                        color="inherit"
                    />
                ),
                component: RealtorHome,
                hideLink: false
            }
        ]
    },
    {
        name: 'Invitations',
        layout: '/organization',
        path: '/invitations',
        icon: (
            <Icon
                as={AiOutlineUserAdd}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        hideLink: false,
        items: [
            {
                name: 'Lenders',
                layout: '/organization',
                path: '/invitations/lenders',
                icon: (
                    <Icon
                        as={MdOutlineHomeWork}
                        width="20px"
                        height="20px"
                        color="inherit"
                    />
                ),
                component: Lenderinvitations,
                hideLink: false
            },
            {
                name: 'Realtors',
                layout: '/organization',
                path: '/invitations/realtors',
                icon: (
                    <Icon
                        as={ImUserTie}
                        width="20px"
                        height="20px"
                        color="inherit"
                    />
                ),
                component: RealtorInvitations,
                hideLink: false

            }
        ]
    },

    {
        name: 'View Transaction',
        layout: '/organization',
        path: '/transaction/:id',
        icon: (
            <Icon
                as={AiFillCreditCard}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: TransactionDetailsHeaders,
        hideLink: true
    },
    {
        name: 'Transaction',
        layout: '/organization',
        path: '/transaction',
        icon: (
            <Icon
                as={AiFillCreditCard}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: TransactionHome
    },
    {
        name: 'Revenue',
        layout: '/organization',
        path: '/revanue',
        icon: (
            <Icon
                as={AiOutlineDollarCircle}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: ComingSoon
    },
    {
        name: 'Message',
        layout: '/organization',
        path: '/message',
        icon: (
            <Icon
                as={BiSolidMessageSquareDetail}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: ComingSoon
    },
    {
        name: 'Support',
        layout: '/organization',
        path: '/support',
        icon: (
            <Icon
                as={BiSupport}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: ComingSoon
    },

    {
        name: 'Signin',
        layout: '/auth',
        path: '/sign-in',
        icon: (
            <Icon
                as={MdAdminPanelSettings}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: SignInCentered,
        hideLink: true
    },
    {
        name: 'Forgot Password',
        layout: '/auth',
        path: '/forgot-password',
        icon: (
            <Icon
                as={MdAdminPanelSettings}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: ForgotPassword,
        hideLink: true
    },
    {
        name: 'Validation',
        layout: '/auth',
        path: '/validate-invitation',
        icon: (
            <Icon
                as={MdAdminPanelSettings}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: ValidationUser,
        hideLink: true
    },
    {
        name: 'Reset Password',
        layout: '/auth',
        path: '/reset-password/:userId/:token',
        icon: (
            <Icon
                as={MdAdminPanelSettings}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: ResetPassword,
        hideLink: true
    }

];

export default routes;
